<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Session existante pour ce compte</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <p class="text">
                Une session active existe déjà pour le compte "{{ data.login }}".
                <br />
                Vous ne pouvez pas ouvrir une seconde instance de HUB4B avec le même compte."
            </p>
            <p class="text">Si vous décidez malgré tout de vous connecter. L'autre session sera fermée."</p>

            <p class="question">Voulez-vous vous connecter quand même (L'autre session sera fermée) ?</p>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" [mat-dialog-close]="false">Non</button>
        <button mat-raised-button class="accent-button" [mat-dialog-close]="true">Oui</button>
    </mat-card-actions>
</mat-card>
